import type FetchService from '../FetchService';
import type { ApiVaultInfo, ApiVaultPreferences, ApiVaultPreferencesUpdate } from './types';

class VaultApi {
  constructor(private fetchService: FetchService) {}

  getVaultInfo() {
    return this.fetchService.get<ApiVaultInfo>('/vault-info');
  }

  getPreferences() {
    return this.fetchService.get<ApiVaultPreferences>('/vault/preferences');
  }

  updatePreferences(values: ApiVaultPreferencesUpdate) {
    return this.fetchService.put<ApiVaultPreferences>('/vault/preferences', values);
  }
}

export default VaultApi;
